import axios from 'axios';

import { APIResponseParsed } from 'types/response';
import { postRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

// ==============================
// TYPES
// ==============================
export type AttachBarnOwlCameraDto = {
  cameraName: string;
  IMEI: string;
  ICCID: string;
  siteId: number;
};

type BarnOwlCamera = {
  cameraId: string;
  IMEI: string;
  cameraName: string;
  cameraModel: string;
  firmware: string;
  cameraStatus: 'Active' | 'Snoozed' | 'Suspended';
  accountId: string;
  parentId: string;
};

// ==============================
// REQUESTS
// ==============================
async function attachBarnOwlCamera(
  enterpriseId: number,
  dto: AttachBarnOwlCameraDto
): Promise<APIResponseParsed<BarnOwlCamera>> {
  try {
    const response = await postRequest<BarnOwlCamera, AttachBarnOwlCameraDto>(
      `/integrations/barn-owl/enterprise/${enterpriseId}/account/attach-camera`,
      dto
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  attachBarnOwlCamera
};
